import { ThunkAction } from 'components/redux/types/ThunkAction';
import { UserLoadBalanceResponseType } from 'moduleBase/actions/types/UserLoadBalanceResponseType';
import { APP_USER_LOAD_BALANCE_SUCCESS, APP_USER_LOAD_BALANCE_URL } from 'moduleBase/constants';
import { FSAWithPayload } from '@collaborator/npm_modules/dist/components/redux';

const appUserLoadBalanceComplete = (
  response: UserLoadBalanceResponseType,
): FSAWithPayload<UserLoadBalanceResponseType> => ({
  type: APP_USER_LOAD_BALANCE_SUCCESS,
  payload: response,
});

const appUserLoadBalance = (): ThunkAction => (
  dispatch,
  getState,
  { networkService },
) => networkService.get<UserLoadBalanceResponseType>(APP_USER_LOAD_BALANCE_URL).then((response) => {
  dispatch(appUserLoadBalanceComplete(response.data));
  return response;
});

export { appUserLoadBalance };
